var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPregnant(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#00d681",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219 451 c-20 -16 -22 -23 -14 -47 9 -24 16 -29 45 -29 29 0 36 5 45 29 8 24 6 31 -14 47 -13 10 -27 19 -31 19 -4 0 -18 -9 -31 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 400 c-17 -17 -20 -25 -11 -28 17 -6 45 22 39 39 -3 9 -11 6 -28 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 310 c-15 -28 -9 -252 7 -257 8 -3 15 11 19 36 7 46 24 55 24 14 0 -16 4 -34 9 -42 14 -21 31 -3 31 32 0 21 7 36 19 44 31 19 37 70 12 104 -12 15 -21 34 -21 42 0 42 -80 64 -100 27z m107 -97 c2 -6 -5 -21 -17 -33 -16 -16 -25 -18 -39 -11 -21 12 -34 38 -25 52 8 14 77 7 81 -8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPregnant);
export default __webpack_public_path__ + "static/assets/pregnant.svg";
export { ForwardRef as ReactComponent };